<h1 mat-dialog-title>Delete Location</h1>
<div mat-dialog-content>
  <div>
    <p *ngIf="!data.active">You're going to delete location: "{{ data.name }}"</p>
    <p *ngIf="data.active">Location "{{ data.name }}" is active and needs deactivation before deletion</p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button *ngIf="!data.active" mat-button [mat-dialog-close]="data" cdkFocusInitial>Confirm</button>
</div>



